import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import FieldLabel from 'src/Components/FieldLabel/FieldLabel';
import TextInput from 'src/Components/TextInput/TextInput';
import {
  faEnvelope,
  faUsersCog,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import NavigateBack from 'src/Components/NavigateBack/NavigateBack';
import {
  getProfileDetails,
  updateProfileDetails,
  updateError,
  updateFieldValue,
  displayToast,
  resetValues,
  displayNativeToast,
  getLanguageDetails,
  getDepartmentsDetails,
  getJobDetails,
} from 'src/Actions/Profile/profileActions';
import _ from 'lodash';
import DropdownField from 'src/Components/Dropdown/DropdownField';
import LoadingButton from 'src/Components/LoadingButton/LoadingButton';
import SuccessToast from 'src/Components/SuccessToast/SuccessToast';
import ProfileLoader from 'src/Components/ProfileLoader/ProfileLoader';
import { validateName } from 'src/Utils';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { withTranslation } from 'react-i18next';
import { PulseLoader } from 'react-spinners';
import { DEFAULT_LANGUAGE } from 'src/Config/constants';

class Profile extends Component {
  state = {
    displayError: false,
    fieldErrors: null,
    entRoles: '-'
  };

  componentDidMount() {
    const { i18n } = this.props;
    this.props.resetValues();
    this.props.getProfileDetails();
    const language = this.props.profile.fieldValue.language || DEFAULT_LANGUAGE; 
    this.props.getJobDetails(language);
    this.props.getDepartmentsDetails(language);
    this.props.getLanguageDetails();
    this.setEntRoles();
    this.updateAnalytics();
    i18n.on('languageChanged', () => {
      this.setEntRoles();
    });
  }

  updateAnalytics = () => {
    const category = window.location.href.replace(window.location.origin, '');
    const digitalData = {
      page: {
        pageInfo: {
          domain: document.domain,
          location: document.location,
          pageName: 'Account',
          siteSection: 'Account',
          pageURL: document.URL,
        },
        category: {
          primaryCategory: category.replace('/', ''),
          pageType: document.domain,
        },
      },
      user: {
        profile: {
          profileInfo: {
            loginStatus: 'logged in',
            profileID: this.props.subscription?.subscriptionInfo?.sfdcUserId,
          },
        },
      },
    };

    AnalyticsService.updateDigitalData(digitalData);
    AnalyticsService.trackEvent('setAnalyticsVariables');
    AnalyticsService.trackEvent('pageLoaded');
  };

  componentDidUpdate(prevProps) {
    // Fetched the data into the store
    if (
      prevProps.subscription.subscriptionInfo !==
      this.props.subscription.subscriptionInfo
    ) {
      if (
        this.props.subscription.subscriptionInfo &&
        Object.keys(this.props.subscription.subscriptionInfo).length > 0
      ) {
        this.setEntRoles();
      }
    }
  }
  saveInputDetails = (type, e, item) => {
    let val =
      type === 'jobTitle' ||
      type === 'accreditingBodyType' ||
      type === 'language' ||
      type === 'department'
        ? item.key
        : item;

    if (val && type !== 'accreditingBodyType') {
      this.props.updateError({ [type]: '' });
    }
    if (type === 'accreditingBodyId') {
      this.props.updateFieldValue({
        [type]: val.trim().length === 0 ? null : val.trim(), /// pass null value only for accBodyId
      });
    } else if (type === 'firstName' || type === 'lastName') {
      this.props.updateFieldValue({ [type]: val });
    } else {
      this.props.updateFieldValue({ [type]: val.trim() });
    }
  };

  setEntRoles = () => {
    let { c } = this.props.subscription;
    const { t } = this.props;
    const ENT_ROLES_MAPPING = {
      PARTICIPANT: t('user'),
      ADMIN: t('admin'),
      TRAINER: t('expert'),
    };
    let d = [];
    if (c && c.length > 0) {
      if (c.includes('ADMIN')) {
        d.push(ENT_ROLES_MAPPING['ADMIN']);
      } else if (c.includes('PARTICIPANT') && c.includes('TRAINER')) {
        d.push(ENT_ROLES_MAPPING['TRAINER']);
      } else if (c.includes('PARTICIPANT')) {
        d.push(ENT_ROLES_MAPPING['PARTICIPANT']);
      }

      if (c.includes('TRAINER') && c.includes('ADMIN')) {
        d.push(ENT_ROLES_MAPPING['TRAINER']);
      }
    }

    if (d.length > 0) {
      this.setState({
        entRoles: d.join(', '),
      });
    }
  };

  clickIcon = (item, id, errorMessage) => {
    if (item === 'accreditingBodyId') {
      this.props.updateFieldValue({ [item]: null });
    } else {
      this.props.updateFieldValue({ [item]: '' });
    }
    if (item !== 'accreditingBodyId') {
      this.props.updateError({ [item]: errorMessage });
    }
    if (document.getElementById(id)) {
      document.getElementById(id).focus();
    }
  };

  navigateBack = () => {
    this.props.displayComponent(false, 'profile');
  };

  updateInputVal = (id, errorMessage) => {
    const { t } = this.props;
    let { fieldValue } = this.props.profile;
    if((id === 'firstName' || id === 'lastName') && fieldValue[id]) {
      this.props.updateFieldValue({ [id]: fieldValue[id].trim().replace(/\s+/g, ' ') });
    }
    if ((id === 'language') && fieldValue[id]) {
      this.props.updateFieldValue({
        [id]: fieldValue[id],
      });
    }
    if (
      id === 'workPhoneNumber' &&
      fieldValue['workPhoneNumber'] &&
      !fieldValue['workPhoneNumber'].match(
        /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g
      )
    ) {
      this.props.updateError({ [id]: t('validPhoneNumberError') });
    } else if (
      id === 'firstName' &&
      fieldValue['firstName'] &&
      !validateName(fieldValue['firstName'])
    ) {
      this.props.updateError({
        ['firstName']: t('validFirstNameError'),
      });
    } else if (
      id === 'lastName' &&
      fieldValue['lastName'] &&
      !validateName(fieldValue['lastName'])
    ) {
      this.props.updateError({ ['lastName']: t('validLastNameError') });
    }
    if (!fieldValue[id] || (fieldValue[id] && !fieldValue[id].trim())) {
      this.props.updateError({ [id]: errorMessage });
    }
  };

  updateUserDetails = async () => {
    let { formError, fieldValue, accrediting, languages } = this.props.profile;
    let errors = formError;
    const { t } = this.props;

    const selectedKey =
      !_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('accreditingBodyType')
        ? this.getAccreditingBodyType(fieldValue, accrediting)
        : accrediting[0];

    await this.props.updateFieldValue({
      ['accreditingBodyType']: selectedKey.key,
    });

    const selectedLanguageKey =
    !_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('language')
      ? this.getLanguage(fieldValue, languages)
      : languages[0];

      await this.props.updateFieldValue({
          ['language']: selectedLanguageKey.key,
        });

    if (typeof window['digitalData'] !== 'undefined') {
      window.digitalData.link = {
        linkName: 'Save Changes',
        linkType: 'Profile Container',
      };
    }

    AnalyticsService.trackEvent('link_click');

    if (!fieldValue['firstName'])
      errors['firstName'] = t('emptyFirstNameError');
    if (!fieldValue['lastName'])
      errors['lastName'] = t('emptyLastNameError');
    if (!fieldValue['workPhoneNumber'])
      errors['workPhoneNumber'] = t('emptyPhoneNumberError');
    this.props.updateError(errors);
    if (Object.keys(formError).length > 0) {
      this.setState({
        displayError: true,
        fieldErrors: { ...formError },
      });
    } else {
      this.setState({
        displayError: false,
      });
      fieldValue.accreditingBodyType =
        fieldValue.accreditingBodyType === null ||
        fieldValue.accreditingBodyType === 'null'
          ? selectedKey.key
          : fieldValue.accreditingBodyType;
      this.props.getJobDetails(this.props.profile.fieldValue.language);
      this.props.getDepartmentsDetails(this.props.profile.fieldValue.language)
      this.props.updateProfileDetails(fieldValue);
    }
  };
  dismissToast = () => {
    this.props.displayToast(false);
  };
  dismissNativeToast = () => {
    this.props.displayNativeToast(false);
  };

  renderProfile = () => {
    let {
      fieldValue,
      formError,
      isLoading,
      showToast,
      showNativeToast,
      profileDetails,
      isProfileDetailsLoading,
      accrediting,
      languages,
      JobDetails,
      departments
    } = this.props.profile;
    let {
      displayError,
      fieldErrors,
      entRoles,
    } = this.state;
    
    const selectedKey =
      !_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('accreditingBodyType')
        ? this.getAccreditingBodyType(fieldValue, accrediting)
        : accrediting[0];
    
    const selectedLanguageKey = 
      !_.isEmpty(fieldValue) && fieldValue.hasOwnProperty('language')
        ? this.getLanguage(fieldValue, languages)
        : languages[0];
    const { t } = this.props;
    let language = languages ? languages : [];
    let accreditingType = accrediting ? accrediting : [];
    
    if (isProfileDetailsLoading) 
      return (
          <div className="profile-container-loader">
            <div className="profile-tag">
              <span className="nav-back-wrapper">
                <NavigateBack text={t('back')} onClick={this.navigateBack} />
              </span>
            </div>
            <ProfileLoader />
          </div>
        )
    else 
      return (
          <div className="profile-container">
            <div className='toast-container'>
              {showToast && <div className="success-toast">
                <SuccessToast
                  message={t('profileUpdated')}
                  dismissToast={this.dismissToast}
                />
              </div>}
              {showNativeToast && <div className="native-toast">
                <SuccessToast
                    message={t('Native Toast')}
                  dismissToast={this.dismissNativeToast}
                />
              </div>}
            </div>
            <div className="profile-wrapper">
              <div className="profile-tag">
                <span className="nav-back-wrapper">
                  <NavigateBack text={t('back')} onClick={this.navigateBack} />
                </span>
                <div className='profile-title-wrapper'>
                  <div className="profile-title">Profile</div>
                </div>
              </div>
            </div>
            <div className="profile-wrapper">
              <div className="account-details-wrapper">
                <div className="account-details">
                  <div className="account-logo">
                    <p className="account-initial">
                      {this.getProfileIconDetails(profileDetails)}
                    </p>
                  </div>
                  <div className="details-wrapper">
                    <div className="details-info">
                      <FontAwesomeIcon icon={faEnvelope} color={'#D7D8DB'} />
                      <p className="details-text">
                        {this.getFieldValue(fieldValue, 'EMAILID')}
                      </p>
                    </div>
                    <div className="details-info">
                      <FontAwesomeIcon icon={faUsersCog} color={'#D7D8DB'} />
                      <p className="details-text">{entRoles}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {displayError && (
              <div className="profile-wrapper">
                <div className="error-wrapper">
                  <FontAwesomeIcon
                    className="error-icon"
                    icon={faExclamationTriangle}
                    color={'#D7D8DB'}
                  />
                  <div className="error-content">
                    <p className="error-header">
                      {t('formErrorText')}
                    </p>
                    <p className="error-sub-value">
                      {t('formErrorSubtext')}
                    </p>
                    {Object.keys(fieldErrors).map((i) => {
                      return (
                        <div key={i} className="error-sub-value">
                          • {`${t(i)}`}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
            <div className="profile-wrapper">
              <div className="profile-field-wrapper">
                <FieldLabel labelText={t('firstName')} isDisabled={isLoading} />
                <TextInput
                  id="firstName"
                  className="textfield-style"
                  onChange={this.saveInputDetails.bind(this, 'firstName')}
                  inputValue={this.getFieldValue(fieldValue, 'FIRSTNAME')}
                  iconClick={this.clickIcon.bind(
                    this,
                    'firstName',
                    'firstName',
                    t('emptyFirstNameError')
                  )}
                  onBlur={this.updateInputVal.bind(
                    this,
                    'firstName',
                    t('emptyFirstNameError')
                  )}
                  isError={!!formError.firstName}
                  errorMessage={this.getErrorMessage(formError, 'FIRSTNAME')}
                  isDisabled={isLoading}
                />
              </div>
              <div className="profile-field-wrapper">
                <FieldLabel labelText={t('lastName')} isDisabled={isLoading} />
                <TextInput
                  id="lastName"
                  className="textfield-style"
                  onChange={this.saveInputDetails.bind(this, 'lastName')}
                  inputValue={this.getFieldValue(fieldValue, 'LASTNAME')}
                  iconClick={this.clickIcon.bind(
                    this,
                    'lastName',
                    'lastName',
                    t('emptyLastNameError')
                  )}
                  onBlur={this.updateInputVal.bind(
                    this,
                    'lastName',
                    t('emptyLastNameError')
                  )}
                  isError={!!formError.lastName}
                  errorMessage={this.getErrorMessage(formError, 'LASTNAME')}
                  isDisabled={isLoading}
                />
              </div>
            </div>
            <div className="profile-wrapper">
              <div className="profile-field-wrapper">
                <FieldLabel
                  labelText={t('workPhoneNumber')}
                  isDisabled={isLoading}
                />
                <TextInput
                  id="workPhoneNumber"
                  className="textfield-style"
                  onChange={this.saveInputDetails.bind(this, 'workPhoneNumber')}
                  inputValue={this.getFieldValue(fieldValue, 'WORKPHONENUMBER')}
                  iconClick={this.clickIcon.bind(
                    this,
                    'workPhoneNumber',
                    'workPhoneNumber',
                    t('emptyPhoneNumberError')
                  )}
                  onBlur={this.updateInputVal.bind(
                    this,
                    'workPhoneNumber',
                    t('emptyPhoneNumberError')
                  )}
                  isError={!!formError.workPhoneNumber}
                  errorMessage={this.getErrorMessage(formError, 'WORKPHONENUMBER')}
                  isDisabled={isLoading}
                />
              </div>
            </div>
            <div className="profile-wrapper">
              <div className="profile-field-wrapper">
                <FieldLabel
                  labelText={t('language')}
                  isRequired={true}
                  isDisabled={isLoading}
                />
                <DropdownField
                  id="language"
                  options={language}
                  onChange={this.saveInputDetails.bind(this, 'language')}
                  inputValue={selectedLanguageKey && selectedLanguageKey.key}
                  isDisabled={isLoading || language.length === 1 ? true : false}
                  isError={false}
                  shadow={true}
                />
              </div>
            </div>
            <div className="profile-wrapper">
              <div className="acc-field-label">
                <FieldLabel
                  labelText={t('accBodyID')}
                  isRequired={false}
                  isDisabled={isLoading}
                />
              </div>
              <div className="profile-field-wrapper">
                <div className="acc-drop-down">
                  <DropdownField
                    id="accreditingBodyType"
                    isRequired={false}
                    onChange={this.saveInputDetails.bind(
                      this,
                      'accreditingBodyType'
                    )}
                    options={accreditingType}
                    inputValue={selectedKey && selectedKey.key}
                    isDisabled={isLoading}
                    isError={false}
                    shadow={true}
                  />
                </div>
              </div>
              <div className="profile-field-wrapper">
                <div className="acc-text">
                  <TextInput
                    id="accreditingBodyId"
                    className="textfield-style"
                    onChange={this.saveInputDetails.bind(
                      this,
                      'accreditingBodyId'
                    )}
                    inputValue={this.getFieldValue(fieldValue, 'ACCREDITINGBODYID')}
                    iconClick={this.clickIcon.bind(
                      this,
                      'accreditingBodyId',
                      'accreditingBodyId'
                    )}
                    onBlur={this.updateInputVal.bind(this, '', '')}
                    isError={false}
                    isDisabled={isLoading}
                    isRequired={false}
                    placeholder={'1234'}
                  />
                </div>
              </div>
            </div>
            <div className="profile-wrapper">
              <div className="profile-field-wrapper">
                <FieldLabel
                  labelText={t('jobtitle')}
                  isRequired={false}
                  isDisabled={isLoading}
                />
                <DropdownField
                  id="jobTitle"
                  onChange={this.saveInputDetails.bind(this, 'jobTitle')}
                  options={JobDetails}
                  inputValue={this.getFieldValue(fieldValue, 'JOBTITLE')}
                  isDisabled={isLoading}
                  isError={!!formError.jobTitle}
                  errorMessage={this.getErrorMessage(formError, 'JOBTITLE')}
                  shadow={true}
                />
              </div>
            </div>
            <div className="profile-wrapper">
              <div className="profile-field-wrapper">
                <FieldLabel
                  labelText={t('colDept')}
                  isRequired={false}
                  isDisabled={isLoading}
                />
                <DropdownField
                  id="department"
                  onChange={this.saveInputDetails.bind(this, 'department')}
                  options={departments}
                  inputValue={this.getFieldValue(fieldValue, 'DEPARTMENT')}
                  isDisabled={isLoading}
                  isError={!!formError.department}
                  errorMessage={this.getErrorMessage(formError, 'DEPARTMENT')}
                  shadow={true}
                />
              </div>
            </div>
            <div className="profile-wrapper">
              <div className="profile-field-wrapper">
                <div className="save-btn">
                  {this.validateLoading(isLoading)}
                </div>
              </div>
            </div>
          </div>
        )
  }

  render() {
    localStorage.setItem('activeItem', 'Account');

    return (
      <>
        {this.props.generic.initialLoad ? <div className='init-loader'>
          <PulseLoader color={'#ffffff'} style={{ marginBottom: 24, marginTop: 24 }} />
        </div> :<>
        {this.renderProfile()}
        </>
        }
      </>
    );
  }

  getProfileIconDetails (profileDetails) {
    let firstLastName = '';
    if(profileDetails)
    {
      if(profileDetails.firstName)
      {
        firstLastName = profileDetails.firstName.charAt(0);
      }
      if(profileDetails.lastName)
      {
        firstLastName = firstLastName + profileDetails.lastName.charAt(0);
      }
      else
      {
        firstLastName = firstLastName + '';
      }
    } 
    return firstLastName;
  }

  validateLoading(isLoading){
    const { t } = this.props;
    if(isLoading){
      return(
      <LoadingButton text={t('saving')} />
      );
    }
    else{
      return(
      <PrimaryButtonGE
        text={t('saveChanges')}
        onClick={this.updateUserDetails}
      />
      );
    }
  }

  getAccreditingBodyType(fieldValue, accrediting){
    if(fieldValue.accreditingBodyType !== 'null' &&
          fieldValue.accreditingBodyType !== null){
            return(
            accrediting
              .filter((x) => x.key === fieldValue.accreditingBodyType)
              .pop()
            );
          }
          else{
            return(
             accrediting[0]
            );
          }
  }

  getLanguage(fieldValue, languages){
    if(fieldValue.language !== 'null' &&
          fieldValue.language !== null && fieldValue.language!== 'undefined' && fieldValue.language!=''){
            return(
            languages
              .filter((x) => x.key === fieldValue.language)
              .pop()
            );
          }
          else{
            return(
             languages[0]
            );
          }
  }

  getFieldValue(fieldValue, val){
    let fieldVal = '';
    switch(val){
      case "ACCREDITINGBODYID":
        fieldVal = fieldValue ? fieldValue.accreditingBodyId : '';
        break;
      case "DEPARTMENT":
        fieldVal = fieldValue ? fieldValue.department : '';
        break;
      case "EMAILID":
        fieldVal = fieldValue ? fieldValue.emailId : '';
        break;
      case "JOBTITLE":
        fieldVal = fieldValue ? fieldValue.jobTitle : '';
        break;
      case "WORKPHONENUMBER":
        fieldVal = fieldValue ? fieldValue.workPhoneNumber : '';
        break;
      case "LASTNAME":
        fieldVal = fieldValue ? fieldValue.lastName : '';
        break;
      case "FIRSTNAME":
        fieldVal = fieldValue ? fieldValue.firstName : '';
        break;
      default:
        break;
    }
    return fieldVal;
  }

  getErrorMessage(formError, err){
    let errorMessage = '';
    switch(err){
      case "DEPARTMENT":
        errorMessage = formError? formError.department : '';
      break;
      case "JOBTITLE":
        errorMessage = formError ? formError.jobTitle : '';
        break;
      case "WORKPHONENUMBER":
        errorMessage = formError ? formError.workPhoneNumber : '';
        break;
      case "LASTNAME":
        errorMessage = formError ? formError.lastName : '';
        break;
      case "FIRSTNAME":
        errorMessage = formError ? formError.firstName : '';
        break;
      case "LANGUAGE":
        errorMessage = formError ? formError.language : '';
        break;
      default:
        break;
    }
    return errorMessage;
  }
}

export const mapStateToProps = ({ profile, subscription,generic }) => ({
  profile,
  subscription,
  generic
});

export const mapDispatchToProps = (dispatch) => ({
  getProfileDetails: () => dispatch(getProfileDetails()),
  getLanguageDetails: () => dispatch(getLanguageDetails()),
  getJobDetails: (language) => dispatch(getJobDetails(language)),
  getDepartmentsDetails: (language) => dispatch(getDepartmentsDetails(language)),
  updateProfileDetails: (req) => dispatch(updateProfileDetails(req)),
  updateFieldValue: (fieldValue) => dispatch(updateFieldValue(fieldValue)),
  updateError: (errorValue) => dispatch(updateError(errorValue)),
  displayToast: (val) => dispatch(displayToast(val)),
  displayNativeToast: (val) => dispatch(displayNativeToast(val)),
  resetValues: () => dispatch(resetValues()),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Profile));
